<template>
  <div
    class="task-detail-empty-state"
    :class="`task-detail-empty-state--${variant}`"
    :data-testid="rootTestId"
  >
    <div class="task-detail-empty-state__icon-wrap" aria-hidden="true">
      <div class="task-detail-empty-state__icon-circle">
        <img
          src="/img/icons/fbc-icons/NoCycle.svg"
          alt=""
          class="task-detail-empty-state__icon"
          data-testid="task-detail__empty-icon"
        />
      </div>
    </div>

    <h3 class="task-detail-empty-state__title" data-testid="task-detail__empty-title">
      {{ copy.TITLE }}
    </h3>

    <p class="task-detail-empty-state__description" data-testid="task-detail__empty-description">
      {{ copy.DESCRIPTION }}
    </p>

    <div class="task-detail-empty-state__actions">
      <v-btn
        v-if="showRetry"
        outlined
        color="primary"
        class="task-detail-empty-state__action text-none"
        data-testid="task-detail__empty-retry-btn"
        @click="$emit('retry')"
      >
        {{ copy.RETRY }}
      </v-btn>
      <v-btn
        color="primary"
        class="task-detail-empty-state__action text-none white--text"
        data-testid="task-detail__empty-back-btn"
        @click="$emit('back')"
      >
        {{ copy.ACTION }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import './TaskDetailEmptyState.scss';
import { TASK_DETAIL_EMPTY_STATE } from '@/modules/financialclose/utils/constants';

export default {
  name: 'TaskDetailEmptyState',
  props: {
    variant: {
      type: String,
      default: 'not-found',
      validator: (value) => ['not-found', 'load-error'].includes(value),
    },
  },
  computed: {
    rootTestId() {
      return `task-detail__empty-state--${this.variant}`;
    },
    copy() {
      return this.variant === 'load-error'
        ? TASK_DETAIL_EMPTY_STATE.LOAD_ERROR
        : TASK_DETAIL_EMPTY_STATE.NOT_FOUND;
    },
    showRetry() {
      return this.variant === 'load-error';
    },
  },
};
</script>
